<ng-template #cartHistoryModal let-modal>
  <div class="ch-modal modal-lg">

    <!-- Header -->
    <div class="ch-header">
      <h5 class="ch-title">Khôi phục giỏ hàng</h5>
      <button class="ch-close-btn" (click)="modal.dismiss()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M15 5L5 15M5 5l10 10" stroke="#1A9A72" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <!-- Notice -->
    <div class="ch-notice">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="flex-shrink:0; margin-top:1px;">
        <circle cx="8" cy="8" r="7.5" stroke="#6B7280"/>
        <path d="M8 7v4M8 5.5v.5" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      <span>Bạn có thể khôi phục giỏ hàng tại đây. Lưu ý: Thông tin sẽ được lưu trong vòng 7 ngày.</span>
    </div>

    <!-- Body -->
    <div class="ch-body" (scroll)="onScroll($event)">

      <!-- Loading -->
      <div *ngIf="isLoading" class="ch-loading">
        <div class="ch-spinner"></div>
        <span>Đang tải...</span>
      </div>

      <!-- Empty -->
      <div *ngIf="!isLoading && historyList.length === 0" class="ch-empty">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
          <circle cx="32" cy="32" r="31" stroke="#E5E7EB" stroke-width="2"/>
          <path d="M20 26h24l-2.4 16.8A2 2 0 0139.62 44H24.38a2 2 0 01-1.98-1.2L20 26z" stroke="#D1D5DB" stroke-width="2" stroke-linejoin="round" fill="none"/>
          <path d="M16 26h32M27 22a5 5 0 0110 0" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <p>Chưa có lịch sử xóa giỏ hàng</p>
      </div>

      <!-- Grouped list: Day → Transaction → Items -->
      <ng-container *ngIf="!isLoading && groupedHistory.length > 0">
        <div *ngFor="let day of groupedHistory; trackBy: trackByDay" class="ch-day-group">

          <div
            class="ch-day-header"
            [class.ch-day-header--collapsed]="isDayCollapsed(day.dayKey)"
            (click)="toggleDay(day.dayKey)"
          >
            <span class="ch-day-label">{{ day.dayLabel }}</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6l4 4 4-4" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <!-- ── Transactions within this day ── -->
          <ng-container *ngIf="!isDayCollapsed(day.dayKey)">
            <div *ngFor="let history of day.transactions; trackBy: trackByTransaction" class="ch-transaction">

              <!-- Transaction sub-header (timestamp) -->
              <div class="ch-transaction-header" style="display: flex; align-items: center; gap: 8px;">
                <input
                  type="checkbox"
                  class="ch-checkbox"
                  [checked]="isTransactionSelected(history)"
                  (change)="toggleTransaction(history, $event)"
                />
                <span class="ch-transaction-time">{{ formatDate(history.createdAt) }}</span>

                <label class="ch-transaction-items-amount">({{ history.items?.length }} sản phẩm)</label>

                <label class="ch-transaction-amount">Tổng số lượng: {{ getTransactionTotalQuantity(history) }}</label>
              </div>

              <!-- Items -->
              <div
                *ngFor="let item of getVisibleItems(history); trackBy: trackByItem"
                class="ch-item"
                [class.ch-item--selected]="selectedMap[history.id]?.[item.sku]"
              >
                <input
                  type="checkbox"
                  class="ch-checkbox"
                  style="margin-left: 12px;"
                  [checked]="selectedMap[history.id]?.[item.sku]"
                  (click)="toggleItem(history, item, $event)"
                />

                <div class="ch-item-img">
                  <img
                    [src]="item.imagesUrls?.[0] || 'assets/images/product.png'"
                    [alt]="item.productName"
                    onerror="this.src='assets/images/product.png'"
                   loading="lazy" />
                </div>

                <div class="ch-item-content">
                  <div class="ch-item-info">
                    <div class="ch-item-name">{{ item.productName }}</div>
                  </div>

                  <div class="ch-item-qty">
                    Số lượng: <strong>{{ item.quantity }}</strong>
                  </div>
                </div>
              </div>

              <!-- Show more / collapse button -->
              <div *ngIf="history.items && history.items.length > 3" style="padding: 10px; text-align: center; border-top: 1px solid #f0f0f0; justify-items: center;">
                <button
                  class="btn btn-link btn-show-more p-0"
                  style="font-size: 14px; font-weight: 500; outline: none; boxShadow: none; justify-content: center;"
                  (click)="toggleTransactionExpand(history.id)"
                >
                  {{ isTransactionExpanded(history.id) ? 'Thu gọn' : 'Xem thêm (' + (history.items.length - 3) + ' sản phẩm)' }}
                </button>
              </div>

            </div>
          </ng-container>
        </div>

        <!-- Loading More -->
        <div *ngIf="isLoadingMore" class="ch-loading-more">
          <div class="ch-spinner-sm"></div>
          <span>Đang tải thêm...</span>
        </div>
      </ng-container>
    </div>

    <!-- Footer -->
    <div class="ch-footer">
      <div style="display: flex; align-items: center; gap: 12px;">
        <span class="ch-selected-count" *ngIf="selectedCount > 0">
          Đã chọn <strong>{{ selectedCount }} sản phẩm</strong>
        </span>
        <button
          *ngIf="selectedCount > 0"
          class="btn btn-link p-0 text-danger text-decoration-none"
          style="font-size: 14px; font-weight: 500;"
          [disabled]="isDeselectingAll"
          (click)="deselectAll()"
        >
          {{ isDeselectingAll ? 'Đang bỏ chọn...' : 'Bỏ chọn' }}
        </button>
      </div>
      <div class="ch-footer-actions">
        <button class="ch-btn-close" (click)="modal.dismiss()">Đóng</button>
        <button
          class="ch-btn-restore"
          [disabled]="!hasAnySelected || isRestoring"
          (click)="restoreSelected()" data-cta="cart.history_restore" data-cta-loc="cart_history"
        >
          <span *ngIf="isRestoring" class="ch-btn-spinner"></span>
          {{ isRestoring ? 'Đang khôi phục...' : 'Khôi phục sản phẩm' }}
        </button>
      </div>
    </div>

  </div>
</ng-template>
